import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// 🔥 Thunk to fetch web content
export const fetchWebContent = createAsyncThunk(
  "webContent/fetchWebContent",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        "https://web1024.docmaster.in:5010/api/webcontents/module/published/5",
      );

      return res.data?.data || res.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

const initialState = {
  data: {}, // mapped by code
  rawData: [], // original array (optional, useful later)
  loading: false,
  error: null,
};

const webContentSlice = createSlice({
  name: "webContent",
  initialState,
  reducers: {
    // optional: clear data if needed
    resetWebContent: (state) => {
      state.data = {};
      state.rawData = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebContent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchWebContent.fulfilled, (state, action) => {
        state.loading = false;

        const dataArray = Array.isArray(action.payload) ? action.payload : [];

        state.rawData = dataArray;

        state.data = dataArray.reduce((acc, item) => {
          acc[item.code] = item;
          return acc;
        }, {});
      })

      .addCase(fetchWebContent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetWebContent } = webContentSlice.actions;

// ✅ Selectors (VERY USEFUL)
export const selectWebContent = (state) => state.webContent.data;
export const selectWebContentLoading = (state) => state.webContent.loading;
export const selectWebContentByCode = (code) => (state) =>
  state.webContent.data[code];

export default webContentSlice.reducer;
